import { initialLandLineProcedureState, LandLineProcedureInterfaceState } from '../state/land-line-procedure.state';
import { ELandLineProceduresActions, LandLineProceduresActions } from '../actions/land-line-procedures.actions';

export function landLineProceduresReducer(state: LandLineProcedureInterfaceState = initialLandLineProcedureState, action: LandLineProceduresActions): LandLineProcedureInterfaceState {
  switch (action.type) {
    case ELandLineProceduresActions.GetLandLineProceduresSuccess: {
      return { ...state, landLineProcedures: action.payload };
    }

    default:
      return state;
  }
}
